module.exports={
  "test": false,
  "races": [
    {
      "id": "49391",
      "date": "3/10/2020",
      "test": false,
      "state": "WA",
      "eevp": 100,
      "party": "Dem",
      "type": "Primary",
      "office": "P",
      "results": [
        {
          "id": "49391",
          "party": "Dem",
          "updated": 1584552596595,
          "precincts": 2000,
          "reporting": 1916,
          "reportingPercentage": 95.8,
          "winners": [],
          "total": 1535467,
          "candidates": [
            {
              "first": "Joe",
              "last": "Biden",
              "party": "Dem",
              "id": "1036",
              "votes": 581891,
              "percentage": 37.9
            },
            {
              "first": "Bernie",
              "last": "Sanders",
              "party": "Dem",
              "id": "1445",
              "votes": 560856,
              "percentage": 36.53
            },
            {
              "first": "Elizabeth",
              "last": "Warren",
              "party": "Dem",
              "id": "62244",
              "votes": 141597,
              "percentage": 9.22
            },
            {
              "first": "Michael",
              "last": "Bloomberg",
              "party": "Dem",
              "id": "32324",
              "votes": 121550,
              "percentage": 7.92
            },
            {
              "first": "Pete",
              "last": "Buttigieg",
              "party": "Dem",
              "id": "67933",
              "votes": 62955,
              "percentage": 4.1
            },
            {
              "first": "Amy",
              "last": "Klobuchar",
              "party": "Dem",
              "id": "51526",
              "votes": 33155,
              "percentage": 2.16
            },
            {
              "first": "Tulsi",
              "last": "Gabbard",
              "party": "Dem",
              "id": "62589",
              "votes": 12992,
              "percentage": 0.85
            },
            {
              "last": "Uncommitted",
              "party": "Dem",
              "id": "100004",
              "votes": 6348,
              "percentage": 0.41
            },
            {
              "first": "Andrew",
              "last": "Yang",
              "party": "Dem",
              "id": "67936",
              "votes": 6323,
              "percentage": 0.41
            },
            {
              "first": "Tom",
              "last": "Steyer",
              "party": "Dem",
              "id": "67935",
              "votes": 3421,
              "percentage": 0.22
            },
            {
              "first": "Michael",
              "last": "Bennet",
              "party": "Dem",
              "id": "59911",
              "votes": 2014,
              "percentage": 0.13
            },
            {
              "first": "Cory",
              "last": "Booker",
              "party": "Dem",
              "id": "63133",
              "votes": 1298,
              "percentage": 0.08
            },
            {
              "first": "John",
              "last": "Delaney",
              "party": "Dem",
              "id": "61562",
              "votes": 568,
              "percentage": 0.04
            },
            {
              "first": "Deval",
              "last": "Patrick",
              "party": "Dem",
              "id": "51516",
              "votes": 499,
              "percentage": 0.03
            }
          ]
        }
      ]
    }
  ]
}